import { FC, useState, useEffect, useRef } from 'react';
import { TopControlRow } from './components/TopControlRow';
import { ControlPanel } from './components/ControlPanel';
import { useMessages } from './messageApi';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { clearFiltersWithoutResetingPage } from './messagesSlice';
import { MessagesTable } from './components/MessagesTable';
import { NoResultsBar } from './components/StyledComponents';
import { SortDirection } from 'utils/types';
import { translateFiltersToPath } from 'utils/translateFiltersToPath';
import styled from 'styled-components';
import { setDate } from 'store/globalSlice';
import { LoadingScreen } from 'components/LoadingScreen';
import { PaginationRow } from './components/PaginationRow';

const MessagesContainer = styled.div`
  padding: 1.25rem 2.5rem;
`;

const TableContainer = styled.div`
  flex: 1;
`;

export const MessageAck: FC = () => {
  const [activeSort, setActiveSort] = useState<{ name: string; direction: SortDirection }>({
    name: '',
    direction: 'none',
  });
  const [searchKeyword, setSearchKeyword] = useState('');
  const updateSort = (name: string, direction: SortDirection) => {
    setActiveSort({ name, direction });
  };
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const { filters, selectedPage } = useAppSelector((state) => state.messageAckReducer);
  const { selectedDate } = useAppSelector((state) => state.globalSlice);

  const currentDate = new Date(selectedDate);
  const { data, isLoading } = useMessages(
    currentDate,
    activeSort,
    searchKeyword,
    translateFiltersToPath(filters),
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearFiltersWithoutResetingPage());
    };
  }, []);

  const setSelectedDate = (date: Date) => {
    dispatch(setDate({ date: date.toString() }));
  };

  const setSearch = (keyword: string) => setSearchKeyword(keyword);
  return (
    <MessagesContainer>
      <TopControlRow selectedDate={currentDate} setSelectedDate={setSelectedDate} />
      <ControlPanel setSearchKeyword={setSearch} selectedDate={currentDate} />
      <TableContainer ref={tableContainerRef}>
        {isLoading ? (
          <LoadingScreen />
        ) : data?.content ? (
          <>
            <MessagesTable
              updateSort={updateSort}
              activeSort={activeSort}
              messages={data.content}
            />
          </>
        ) : (
          <NoResultsBar>No results for this date</NoResultsBar>
        )}
      </TableContainer>

      {data && data.content.length > 0 && (
        <PaginationRow
          currentPage={selectedPage}
          totalPages={data.totalPages}
          totalElements={data.totalElements}
        />
      )}
    </MessagesContainer>
  );
};
